import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { DataWidgetComponent } from './data-widget.component';
import { MobileAppPtiRanking } from '../models/mobileAppPtiRanking';

@Component({
  template: `<a
    [attr.title]="data?.appTitle"
    enTooltip
    [routerLink]="insightsRouterLink"
    [queryParams]="insightsQueryParamsRouterLink"
  >
    <div class="d-flex align-items-center">
      <img
        src="{{ data?.appIcon }}"
        [attr.alt]="data?.appTitle + ' Icon'"
        class="mr-2 rounded"
        width="50"
        (error)="imageNotFound($event)"
      />
      <div class="title">{{ data?.appTitle }}</div>
    </div>
  </a>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppNameOnlyComponent
  extends DataWidgetComponent
  implements OnInit
{
  @Input()
  data: MobileAppPtiRanking;

  ngOnInit(): void {
    super.ngOnInit();
  }

  imageNotFound(event: any) {
    this.data.appIcon = '/assets/icons/icon-72x72-grey.png';
  }
}
